import {
  all, call, fork, put, takeLatest,
} from "redux-saga/effects";
import * as Actions from "./actions";
import * as Api from "@amplio-common/treatments/api";
import { toast } from "react-toastify";

function* loadTreatmentsRequestHandler(action) {
  try {
    const { response } = yield call(Api.loadTreatments, action.payload);
    yield put(Actions.loadTreatments.success(response));
  } catch (error) {
    yield put(Actions.loadTreatments.failure(error));
  }
}

function* watchLoadTreatmentsRequest() {
  yield takeLatest(Actions.LOAD_TREATMENTS.REQUEST, loadTreatmentsRequestHandler);
}

function* updateTreatmentRequestHandler(action) {
  try {
    const { response } = yield call(Api.updateTreatment, action.payload.treatmentId, action.payload.treatment);
    yield put(Actions.updateTreatment.success(response));
  } catch (error) {
    yield put(Actions.updateTreatment.failure(error));
    // toast...?
  }
}

function* watchUpdateTreatmentRequest() {
  yield takeLatest(Actions.UPDATE_TREATMENT.REQUEST, updateTreatmentRequestHandler);
}

function* cancelTreatmentRequestHandler(action) {
  try {
    const { response } = yield call(Api.cancelTreatment, action.payload.treatmentId, action.payload.treatment);
    yield put(Actions.cancelTreatment.success(response));
  } catch (error) {
    yield put(Actions.cancelTreatment.failure(error));
    // toast...?
  }
}

function* watchCancelTreatmentRequest() {
  yield takeLatest(Actions.CANCEL_TREATMENT.REQUEST, cancelTreatmentRequestHandler);
}

function* createTreatmentRequestHandler(action) {
  try {
    const { response } = yield call(Api.createTreatment, action.payload.treatment);
    yield put(Actions.createTreatment.success(response));
  } catch (error) {
    yield put(Actions.createTreatment.failure(error));
    if (error && error.conflict) {
      toast.error(
        "Failed to create session, an existing session for student or therapist already exists. please select a different time slot",
      );
    }
  }
}

function* watchCreateTreatmentRequest() {
  yield takeLatest(Actions.CREATE_TREATMENT.REQUEST, createTreatmentRequestHandler);
}

function* rescheduleTreatmentRequestHandler(action) {
  try {
    const { response } = yield call(Api.rescheduleTreatment, action.payload.treatmentId, action.payload.treatment);
    yield put(Actions.rescheduleTreatment.success(response));
  } catch (error) {
    yield put(Actions.rescheduleTreatment.failure(error));
    // toast...?
  }
}

function* watchRescheduleTreatmentRequest() {
  yield takeLatest(Actions.RESCHEDULE_TREATMENT.REQUEST, rescheduleTreatmentRequestHandler);
}

export default function* treatmentSagas() {
  yield all([
    fork(watchLoadTreatmentsRequest),
    fork(watchUpdateTreatmentRequest),
    fork(watchCreateTreatmentRequest),
    fork(watchRescheduleTreatmentRequest),
    fork(watchCancelTreatmentRequest),
  ]);
}
